import { Dropdown } from "semantic-ui-react";

/**
 * Same as <Dropdown multiple />, but wraps labels in a scrollable container.
 */
class ScrollableDropdown extends Dropdown {
  constructor(...params) {
    super(...params);

    const prevRenderLabels = this.renderLabels;
    const prevRenderSearchInput = this.renderSearchInput;
    const prevRenderSearchSizer = this.renderSearchSizer;

    this.renderLabels = () => {
      return (
        <div className="scrollable-droprown-contents">
          {prevRenderLabels() || this.props.defaulttrigger}
          {prevRenderSearchInput()}
          {prevRenderSearchSizer()}
        </div>
      );
    };
    this.renderSearchInput = () => null;
    this.renderSearchSizer = () => null;
    this.renderText = () => null;

    // Not specific to ScrollableDropdown, but it would be a sane behaviour
    // not to clear search query in most of our usecases.
    // biome-ignore lint/suspicious/noEmptyBlockStatements: <refactoring needed for why it was used like this>
    this.clearSearchQuery = () => {};
  }
}

export default ScrollableDropdown;
